<script setup lang="ts">
interface Props {
    sets: number;
}
defineProps<Props>();
</script>

<template>
    <div
        class="w-4 h-4 text-xs sets_to_play inline-flex text-black justify-center items-center align-top"
        :title="sets"
    >
        {{ sets }}
    </div>
</template>

<style scoped>
.sets_to_play {
    background-image: url(./../images/sets.png);
}
</style>
